
import React from 'react';
import { format, addDays } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CycleData } from '@/utils/cycleTracking';
import { useNavigate } from 'react-router-dom';
import { UserProgress } from '@/types/user';
import Gamification from '@/components/Gamification';
import ProgressSummaryCards from './ProgressSummaryCards';
import { useIsMobile } from '@/hooks/use-mobile';

interface OverviewTabProps {
  selectedDate: Date;
  handleDateSelect: (date: Date) => void;
  cycleData: CycleData | null;
  currentLesson: any;
  selectedDay: number;
  userProgress: UserProgress;
}

const OverviewTab: React.FC<OverviewTabProps> = ({
  selectedDate,
  handleDateSelect,
  cycleData,
  currentLesson,
  selectedDay,
  userProgress
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-6 animate-in fade-in-50">
      <ProgressSummaryCards userProgress={userProgress} />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Gamification component - pass null for currentDay and lessonsCompleted to hide those sections */}
        <div className={`${isMobile ? "order-1" : "order-none lg:col-span-1"}`}>
          <Gamification 
            streak={userProgress.streak || 0} 
            points={userProgress.points || 0} 
            completedDay={userProgress.completedDays?.includes(userProgress.currentDay) || false}
            earnedPoints={10}
            currentDay={null}
            lessonsCompleted={null}
          />
        </div>
        
        <div className={`${isMobile ? "order-2" : "order-none lg:col-span-2"} space-y-6`}>
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg">Daily Lesson</CardTitle>
              <CardDescription>
                Day {selectedDay}: {currentLesson?.title || 'No lesson available'}
              </CardDescription>
            </CardHeader>
            <CardContent className="max-h-[300px] overflow-y-auto">
              {currentLesson ? (
                <div className="prose prose-sm max-w-none">
                  <p>{currentLesson.subtitle}</p>
                  <div dangerouslySetInnerHTML={{ __html: currentLesson.content.slice(0, 200) + '...' }} />
                  <Button 
                    variant="outline" 
                    onClick={() => navigate(`/lesson/${selectedDay}`)}
                  >
                    Read Full Lesson
                  </Button>
                </div>
              ) : (
                <p>No lesson content available for this day.</p>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
